import { ReactNode } from 'react';

interface SectionProps {
  title: string;
  children: ReactNode;
}

const Section = ({ title, children }: SectionProps) => (
  <section className="grid gap-4 rounded-2xl bg-neutral-10 p-4">
    <h3 className="text-lg font-semibold text-neutral-90">{title}</h3>
    {children}
  </section>
);

export default Section;
